module.exports = __webpack_public_path__ + "assets/img/select_products4.0a7ea23b.svg";